import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-xl font-semibold text-foreground-900">
              ASMR导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/60">
            <div className="flex flex-col gap-1 mt-2">
              <Link
                to="/"
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/'
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}